import { theme } from '@by-miles/bymiles-styles'
import styled from 'styled-components'

export const HowStyles = styled.div`
  max-width: 100%;
  height: 100%;
  position: relative;
  margin: ${props =>
    props.showDiscountBanner
      ? `95px ${theme.grid.resolution.mobile.margin}px`
      : `0 ${theme.grid.resolution.mobile.margin}px`};
  @media (min-width: ${theme.grid.resolution.tablet.width}px) {
    width: ${theme.grid.resolution.tablet.container}px;
    margin: ${props => (props.showDiscountBanner ? `72px auto` : `0 auto`)};
  }
  @media (min-width: ${theme.grid.resolution.desktop.width}px) {
    width: ${theme.grid.resolution.desktop.container}px;
  }

  .tracker-activation-wrapper {
    margin-top: 32px;
    margin-bottom: ${theme.grid.spacing.s}px;
    @media (min-width: ${theme.grid.resolution.tablet.width}px) {
      margin-bottom: ${theme.grid.spacing.md}px;
    }
    position: relative;
    .checkbox-button {
      button {
        @media (min-width: ${theme.grid.resolution.tablet.width}px) {
          right: 34px;
          bottom: 53px !important;
        }
      }
    }
  }
`
